import React, { useState, useEffect } from 'react'
import { bookApi, categoryApi } from '../services/api'

const BooksSection = () => {
  const [books, setBooks] = useState([])
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      setLoading(true)
      const [booksRes, categoriesRes] = await Promise.all([
        bookApi.list(),
        categoryApi.list('book')
      ])
      
      if (booksRes.code === 0) setBooks(booksRes.data)
      if (categoriesRes.code === 0) setCategories(categoriesRes.data)
    } catch (err) {
      setError('加载数据失败')
    } finally {
      setLoading(false)
    }
  }

  const getBooksByCategory = (categoryId) => {
    return books.filter(book => book.category_id === categoryId)
  }

  const renderLevelDots = (level) => {
    return (
      <div className="book-level">
        {[1, 2, 3, 4, 5].map(i => (
          <span key={i} className={`level-dot ${i <= level ? 'filled' : ''}`}></span>
        ))}
      </div>
    )
  }

  if (loading) {
    return (
      <section className="section">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>加载中...</p>
        </div>
      </section>
    )
  }

  if (error) {
    return (
      <section className="section">
        <div className="error">{error}</div>
      </section>
    )
  }

  return (
    <section className="section">
      <div className="section-header">
        <span className="section-title">AI 书籍精选</span>
        <span className="section-count">// 必读经典</span>
      </div>
      
      {categories.map(category => {
        const categoryBooks = getBooksByCategory(category.id)
        if (categoryBooks.length === 0) return null
        
        return (
          <div key={category.id}>
            <div className="category-label">{category.name}</div>
            <div className="card-grid grid-2">
              {categoryBooks.map((book, index) => (
                <div 
                  key={book.id} 
                  className="book-card card-anim"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <div 
                    className="book-cover" 
                    style={{ background: '#0a0a0a' }}
                  >
                    {book.cover_icon && book.cover_icon.startsWith('data:image') ? (
                      <img src={book.cover_icon} alt={book.title} style={{ width: '100%', height: 'auto', display: 'block' }} />
                    ) : book.cover_icon && book.cover_icon.startsWith('http') ? (
                      <img src={book.cover_icon} alt={book.title} style={{ width: '100%', height: 'auto', display: 'block' }} />
                    ) : (
                      book.cover_icon || '📚'
                    )}
                  </div>
                  <div className="book-meta">
                    <div className="book-title">{book.title}</div>
                    {book.author && <div className="book-author">{book.author}</div>}
                    <div className="book-desc">{book.description}</div>
                    {renderLevelDots(book.level)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </section>
  )
}

export default BooksSection
